import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import iconLogo from "../../../assets/icon-logo.png";

interface Team {
  id: number;
  team_id: string;
  team_name: string;
  payment_status: string;
  [key: string]: any;
}

interface ReadyForPaymentStatusProps {
  team: Team;
  onUpdate: () => void;
}

const ReadyForPaymentStatus: React.FC<ReadyForPaymentStatusProps> = ({
  team,
}) => {
  const navigate = useNavigate();

  const handlePaymentClick = () => {
    navigate("/dashboard/payment/form?team=" + team.team_id);
  };

  return (
    <div className="bg-white rounded-lg p-6 shadow-sm">
      <div className="text-center py-8">
        {/* Icon/Image placeholder */}
        <div className="w-20 mx-auto flex items-center justify-center">
          <img src={iconLogo} className="w-full" alt="Logo" />
        </div>

        <p className="text-sm text-gray-600 mt-4">
          Congratulations, your team’s application has been approved.
        </p>

        <div className="space-y-2">
          <p className="text-lg font-semibold text-gray-900 mb-2">
            Your team is ready for Payment
          </p>

          {team.payment_status === "paid" ? (
            <div className="w-full bg-green-100 text-green-800 py-3 px-6 rounded-lg font-medium">
              ✅ Payment Complete - You're all set!
            </div>
          ) : (
            <>
              <button
                onClick={handlePaymentClick}
                className="w-full bg-gray-800 text-white py-3 px-6 rounded-lg hover:bg-gray-700 transition-colors font-medium"
              >
                Complete Payment
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReadyForPaymentStatus;
